import React, { useState } from 'react';
import axios from 'ps-components/lib/apiClient';
import './AddSuperAdmin.scss';
//components
import AdvancedTable from 'ps-components/AdvancedTable/AdvancedTable';
import { getGenericRow } from 'ps-components/AdvancedTable/GenericGrid/GenericGridFunctions';
import { Input } from 'ps-design';
import { Button } from '../../../../../../ps-aspect-design';
import { useToast } from 'ps-shared-ui/v4/Toast';
import ConfirmationModal from './ConfirmationModal/ConfirmationModal';

const toastConfig = {
  duration: 10000,
  isCloseable: true,
  type: 'error'
};

function AddSuperAdmin() {
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [users, setUsers] = useState([]);
  const [activeRow, setActiveRow] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const findUser = async () => {
    try {
      const res = await axios.apiGet('/api/generic-user/superadmin/findAnyUser', { params: { firstName, lastName } });
      if (res.data.success) setUsers(res.data.users);
      else toast(res.data.message || 'There was a prooblem finding users', toastConfig);
    } catch (err) {
      toast('Error trying to find user: ' + err, toastConfig);
    }
  };

  const onKeyDown = e => e.key === 'Enter' && findUser();

  const makeSuperAdmin = async () => {
    setLoading(true);
    try {
      const res = await axios.apiPost('/api/generic-user/superadmin/grantSuperAdmin', { userId: activeRow.user_id });
      if (!res.data.success) {
        toast(res.data.message || 'Attempt to set user as superadmin failed', toastConfig);
      } else {
        if (activeRow) setUsers(users.filter(u => u.user_id !== activeRow.user_id));
      }
    } catch (err) {
      console.log('could not make user superadmin ', err);
      toast('could not make user superadmin ' + err.toString(), toastConfig);
    }
    setLoading(false);
    setActiveRow(null);
  };

  return (
    <div className="addsuperadmin">
      <h3>Add SuperAdmin</h3>
      <div className="user-search">
        <label>First Name</label>
        <Input type="text" name="first name" onChange={(un, value) => setFirstName(value)} onKeyDown={onKeyDown} />
        <label>Last Name</label>
        <Input type="text" name="last name" onChange={(un, value) => setLastName(value)} onKeyDown={onKeyDown} />
        <Button onClick={findUser}>Search</Button>
      </div>
      <AdvancedTable
        columnHeaders={[
          { Header: 'First Names', accessor: 'first_names' },
          { Header: 'Last Name', accessor: 'last_name' },
          { Header: 'Email', accessor: 'email' },
          { Header: 'Privilege', accessor: 'privilege' },
          { Header: 'Status', accessor: 'member_state' },
          {
            Header: 'Action',
            accessor: 'user_id',
            customRender: (row, key) => {
              return (
                <div>
                  <span className="make-admin-link" onClick={() => setActiveRow(row)}>
                    Make SuperAdmin
                  </span>
                </div>
              );
            }
          }
        ]}
        rowData={users}
        getDataRow={getGenericRow}
      />
      <ConfirmationModal
        onCancel={() => setActiveRow(null)}
        onConfirm={makeSuperAdmin}
        row={activeRow}
        show={Boolean(activeRow)}
        loading={loading}
      />
    </div>
  );
}

export default AddSuperAdmin;
